import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Gallery.css';

const Gallery = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageErrors, setImageErrors] = useState({});

  const handleImageError = (imageId) => {
    setImageErrors(prev => ({ ...prev, [imageId]: true }));
  };

  // Gallery: uploaded flight landscape images
  const galleryItems = [
    { id: 1, type: 'image', src: '/gallery/IMG_4327.JPEG', altKey: 'altLandscape', titleKey: 'budapestAbove', descKey: 'descAerial' },
    { id: 2, type: 'image', src: '/gallery/IMG_4406.JPEG', altKey: 'altPanorama', titleKey: 'cityPanorama', descKey: 'descLandscape' },
    { id: 3, type: 'image', src: '/gallery/IMG_4700.JPEG', altKey: 'altAerial', titleKey: 'aerialPerspective', descKey: 'descSightseeing' },
    { id: 4, type: 'image', src: '/gallery/IMG_5773.JPEG', altKey: 'altLandscape2', titleKey: 'flightLandscape', descKey: 'descCockpit' },
    { id: 5, type: 'image', src: '/gallery/flight-5.JPEG', altKey: 'altBudapest', titleKey: 'overCity', descKey: 'descBudapest' }
  ];

  const openLightbox = (item) => {
    if (item.type === 'video' || !imageErrors[item.id]) {
      setSelectedImage(item);
    }
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <h1>{t('gallery.title')}</h1>
        <p>{t('gallery.subtitle')}</p>
      </div>

      <div className="container">
        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <div
              key={item.id}
              className="gallery-item"
              onClick={() => openLightbox(item)}
            >
              <div className="gallery-image-wrapper">
                {item.type === 'video' ? (
                  <>
                    <video
                      src={item.src}
                      poster={item.poster}
                      muted
                      loop
                      preload="metadata"
                      className="gallery-video-thumb"
                    />
                    <span className="gallery-video-badge" aria-hidden="true">{t('gallery.film')}</span>
                    <div className="gallery-video-play">
                      <span className="gallery-video-play-icon">▶</span>
                    </div>
                    <div className="gallery-overlay">
                      <h3>{item.titleKey ? t(`gallery.${item.titleKey}`) : item.title}</h3>
                      <span className="gallery-view-icon">▶</span>
                    </div>
                  </>
                ) : !imageErrors[item.id] ? (
                  <>
                    <img
                      src={item.src}
                      alt={item.alt}
                      onError={() => handleImageError(item.id)}
                    />
                    <div className="gallery-overlay">
                      <h3>{item.title}</h3>
                      <span className="gallery-view-icon">🔍</span>
                    </div>
                  </>
                ) : (
                  <div className="image-placeholder">{t('gallery.loadingImage')}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>×</button>
            {selectedImage.type === 'video' ? (
              <video src={selectedImage.src} controls autoPlay className="lightbox-video" />
            ) : (
              <img src={selectedImage.src} alt={selectedImage.alt} />
            )}
            <h3>{selectedImage.title}</h3>
            {selectedImage.description && <p>{selectedImage.description}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
